module.exports = new __parcel__URL__("help-circle.9bda9467.png").toString();